import axios from "axios";

export function apiGetSpaces(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS + "api/spaces" + (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetSpace(instance, id) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/spaces/" + id, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveSpace(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/spaces", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return error.response;
    });
}

export function apiUpdateSpace(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/spaces/" + id, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteSpace(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/spaces/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
